import { InternalShipmentGroup, ShipmentGroup } from '../../models/shipment-group';
import { Truck } from '../../models/truck';

export const isInternalShipmentGroupAllowed = (truck: Truck, tagMap: Record<string, string> = {}) =>
  (internalShipmentGroup: InternalShipmentGroup): boolean => {
    if (!truck.loadingRestrictions || truck.loadingRestrictions.length === 0) {
      return true;
    }

    const { loadingRestrictions } = truck;

    const restrictCarrierAccount = loadingRestrictions.some(
      restriction => restriction.restrictionType === 'ShipmentQualifierTruckLoadingRestriction::carrier-account',
    );
    const restrictOther = loadingRestrictions.some(
      restriction => restriction.restrictionType !== 'ShipmentQualifierTruckLoadingRestriction::carrier-account',
    );

    const isCarrierAccountAllowed = loadingRestrictions.some(
      restriction => internalShipmentGroup.carrierAccountKey === restriction.value,
    );
    const isTagAllowed = loadingRestrictions.some(
      restriction => restriction.value === tagMap[internalShipmentGroup.tag || ''],
    );

    if (restrictCarrierAccount && !isCarrierAccountAllowed) {
      return false;
    }

    if (restrictOther && !isTagAllowed) {
      return false;
    }

    return true;
  };

export const isShipmentGroupAllowed = (truck: Truck, tagMap: Record<string, string> = {}) =>
  (shipmentGroup: ShipmentGroup): boolean => {
    if (!truck.loadingRestrictions || truck.loadingRestrictions.length === 0) {
      return true;
    }

    const { loadingRestrictions } = truck;

    const restrictCarrierAccount = loadingRestrictions.some(
      restriction => restriction.restrictionType === 'ShipmentQualifierTruckLoadingRestriction::carrier-account',
    );
    const restrictOther = loadingRestrictions.some(
      restriction => restriction.restrictionType !== 'ShipmentQualifierTruckLoadingRestriction::carrier-account',
    );

    const isTagAllowed = loadingRestrictions.some(
      restriction => restriction.value === tagMap[shipmentGroup.tag || ''],
    );

    const isCarrierAccountAllowed = shipmentGroup.internalShipmentGroups.reduce(
      (isAllowed, { key }) => isAllowed && loadingRestrictions.some(
        restriction => key === restriction.value,
      ),
      true,
    );

    if (restrictCarrierAccount && !isCarrierAccountAllowed) {
      return false;
    }

    if (restrictOther && !isTagAllowed) {
      return false;
    }

    return true;
  };
